import React from 'react';
import { Box } from 'native-base';
import { useSpringBigStore, useI18n } from '@springbig/shared';
import Alert from '~/shared/Alert';
import { useGeneralStyles, useMenuStyles } from '~/shared/styles';
import { useAppNavigate } from '..';
import Button from '~/shared/Button';
import { useAuthorization } from '~/hooks/auth';
import Loading from '~/shared/Loading';
import Section from '~/shared/Section';
import { AccountForm } from '~/pages/profile/AccountForm';

const AccountInformationScreen = () => {

    const { member } = useSpringBigStore();
    const { t } = useI18n();
    const [showDeleteModal, setShowDeleteModal] = React.useState(false);

    const { navigate, params } = useAppNavigate();
    const gStyle = useGeneralStyles();

    const { isLoadingAuth } = useAuthorization();
    const {
        background
    } = useMenuStyles();

    const handleDeleteAccount = () => {

        navigate(`w/${params.wallet_id}/profile/menu/account/remove`);
    };

    if (isLoadingAuth) {
        return <Loading isLoading={isLoadingAuth} />;
    }

    return (
        <Section
            flex={1}
            w={'100%'}
            overflowY={'auto'}
            overflowX={'hidden'}
        >
            { member && <AccountForm /> }
            <Box alignItems={'center'} my={2} >
                <Button
                    bg={gStyle.button_danger_background}
                    _text={{
                        color: gStyle.button_danger_text
                    }}
                    h={12}
                    w={32}
                    onPress={(() => {

                        setShowDeleteModal(true);
                    })}
                >
                    {
                        t('accountInformation.delete_account')
                    }
                </Button>
            </Box>
            {
                showDeleteModal && (
                    <Alert
                        setAcceptAlert={() => {

                            setShowDeleteModal(false);
                            handleDeleteAccount();
                        }}
                        setCancelAlert={() => setShowDeleteModal(false)}
                        showAlert={showDeleteModal}
                        message={t('accountInformation.delete_account_message')}
                        title={t('accountInformation.delete_account_title')}
                    />
                )
            }
        </Section>
    );
};

export default AccountInformationScreen;
